import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import type { Review } from '../../lib/api';

interface ReviewCardProps {
  review: Review;
}

export function ReviewCard({ review }: ReviewCardProps) {
  const { t } = useTranslation();
  const stars = review.rating / 100;
  const date = new Date(review.createdAt).toLocaleDateString();

  const initials = review.reviewer?.name
    ?.split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || 'U';

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center text-primary-foreground text-sm font-medium flex-shrink-0">
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <span className="font-medium text-foreground truncate">
              {review.reviewer?.name || t('reviewCard.anonymous', 'Anônimo')}
            </span>
            <span className="text-xs text-muted-foreground flex-shrink-0">{date}</span>
          </div>

          <div className="flex items-center gap-0.5 mt-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star
                key={i}
                size={12}
                className={cn(
                  i <= stars
                    ? 'fill-yellow-400 text-yellow-400'
                    : 'text-muted-foreground/30'
                )}
              />
            ))}
          </div>

          {review.title && (
            <p className="font-medium text-sm text-foreground mt-2">{review.title}</p>
          )}

          {review.content && (
            <p className="text-sm text-muted-foreground mt-1">{review.content}</p>
          )}
        </div>
      </div>
    </div>
  );
}
